import { Suspense, useState } from "react";
import PhotoAlbum from 'react-photo-album';
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

// import optional lightbox plugins
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Captions from "yet-another-react-lightbox/plugins/captions";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import "yet-another-react-lightbox/plugins/captions.css";
import { Col, Row } from "react-bootstrap";


export const Gallery = ({ selLanguage }) => {
    const [index, setIndex] = useState(-1);
    const photos = [
        { src: "/AboutProjcet/091A8287.jpg", width: 2500, height: 1667, alt: "Фойе Лениград Центра" },
        { src: "/AboutProjcet/091A8294.jpg", width: 2500, height: 1667, alt: "Фойе Лениград Центра" },
        { src: "/AboutProjcet/091A8301.jpg", width: 2500, height: 1667, alt: "Фойе Лениград Центра" },
        { src: "/AboutProjcet/LC141022_001.jpg", width: 2500, height: 1667, alt: "Фойе Лениград Центра" },
        { src: "/AboutProjcet/LC141022_011.jpg", width: 2500, height: 1667, alt: "Фойе Лениград Центра" },
        { src: "/AboutProjcet/Photo_014.jpg", width: 2500, height: 1667, alt: "Фойе Лениград Центра" },
    ]
    return (
        <>
            {selLanguage === "en" ?
                <>
                    <p>
                        <strong>Leningrad Centre Gallery</strong> is located on the second floor of the mansion – it’s a space designed by Ricardo Bofill, where art speaks with a powerful voice. The focus here is on things that are inextricably linked to the world of theatre: painting, cinema and high fashion.
                    </p>
                    <p>
                        World-renowned photographers Pit Buehler and Kevin Ohana have presented their works in the gallery space, with artists from the show space participating in their spectacular shoots. In 2018 and 2019, in collaboration with the Petersburg Gallery, exhibitions were also opened featuring renowned artists from the World of Art Association, with works by Valentin Serov, Boris Kustodiev, Filipp Malyavin and other masters. In 2023, the gallery presented An Ordinary Miracle – an exhibition of sketches for films, theatre works and graphics by the preeminent Soviet film artists Mikhail Kartashov and Lyudmila Kusakova.
                    </p>
                    <p>
                        Exhibitions follow one after the other, with each becoming its own individual statement. Recent projects: Tatyana Parfenova’s Conversation with Flowers – a wordless dialogue in which color and matter were the main interlocutors, and the exhibition WE. THEATRE/FASHION, which brought the stage and couture costumes together in honor of the tenth anniversary of Leningrad Centre. Today, the gallery’s walls are showcasing Maxim Korolkov’s exhibition Don't Look Now – the perspective of a young artist who has something to say.
                    </p>
                    <p>
                        The gallery continues the cultural mission of these walls: to be a place where the city meets new ideas.
                    </p>
                </>
                :
                <>
                    <p>
                        <strong>Галерея Ленинград Центра</strong> расположилась на втором этаже особняка — и это пространство, спроектированное Рикардо Бофиллом, где искусство говорит в полный голос. В фокусе здесь то, что неразрывно связано с миром театра: живопись, кино и высокая мода.
                    </p>
                    <p>
                        В пространстве галереи свои проекты представляли звезды мировой фотографии Пит Бюлер и Кевин Охана, в чьих грандиозных съемках принимали участие артисты шоу-пространства. В 2018 и 2019 гг. совместно с галереей «Петербург» были открыты экспозиции прославленных художников объединения «Мир искусства» с работами Валентина Серова, Бориса Кустодиева, Филиппа Малявина и других мастеров. В 2023 году галерея показывала «Обыкновенное чудо» — экспозицию эскизов к фильмам, театральных работ и графики выдающихся советских кинохудожников Михаила Карташова и Людмилы Кусаковой.
                    </p>
                    <p>
                        Выставки сменяют друг друга, и каждая становится отдельным высказыванием. Из недавних проектов: «Разговор цветами» Татьяны Парфеновой — бессловесный диалог, в котором главными собеседниками стали цвет и материя, выставка «МЫ. ТЕАТР/МОДА» соединила сцену и костюмы от кутюр в честь десятилетия Ленинград Центра. А сегодня стены галереи принимают экспозицию Максима Королькова «А ты не смотри» — взгляд молодого художника, которому есть что сказать.
                    </p>
                    <p>
                        Галерея продолжает культурную миссию этих стен: быть местом встречи города с новыми идеями.
                    </p>
                </>
            }
            <div>
                <Suspense>
                    <PhotoAlbum columns={3} layout="masonry" photos={photos} onClick={({ index }) => setIndex(index)} />
                    <Lightbox
                        slides={photos}
                        open={index >= 0}
                        index={index}
                        close={() => setIndex(-1)}
                        // enable optional lightbox plugins
                        plugins={[Slideshow, Thumbnails, Zoom, Captions]}
                    />
                </Suspense>
            </div>
        </>
    )
}